import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

// Custom hook to use the AuthContext
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        // Check if auth tokens exist in local storage
        return !!localStorage.getItem('token')
    });

    const login = () => {
        setIsAuthenticated(true);
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setIsAuthenticated(false);
    };

    useEffect(() => {
        // Optional: Log user out after a specific time or check tokens' validity
        const checkAuth = () => {
            const token = localStorage.getItem('token');

            // Here you can add any logic to verify tokens if needed
            // For now, it just checks if they exist
            setIsAuthenticated(!!token)
        };

        checkAuth();
    }, []); // Runs once when the component mounts

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
